import { Alert, AlertDescription, AlertIcon, VStack } from "@chakra-ui/react";
import { PatientId } from "../../../shared/schema/schema";
import MedicationTable from "../../patient/components/MedicationTable";

/**
 * Medications are patient records that also appear on the finalized service
 * plan, so this step reuses the patient profile's own table — editable here, and
 * edits show up on the Medication profile tab too. Not locked when the plan is
 * finalized: the plan snapshots these at finalize time, while the patient's
 * records keep living on.
 */

interface Props {
  patientId: PatientId;
}

export default function ServicePlanMedicationsStep({ patientId }: Props) {
  return (
    <VStack align="stretch" spacing={4}>
      <Alert status="info">
        <AlertIcon />
        <AlertDescription>
          These are the patient&apos;s medications — edits here also apply on the Medication profile
          tab. They are included on the finalized service plan.
        </AlertDescription>
      </Alert>
      <MedicationTable patientId={patientId} />
    </VStack>
  );
}
